var MyProfileDataTestIdEnum = /* @__PURE__ */ ((MyProfileDataTestIdEnum2) => {
  MyProfileDataTestIdEnum2["MY_PROFILE_DOCUMENT_NUMBER_INPUT"] = "my-profile-document-number-input";
  MyProfileDataTestIdEnum2["MY_PROFILE_LEGAL_NAME_INPUT"] = "my-profile-legal-name-input";
  MyProfileDataTestIdEnum2["MY_PROFILE_SOCIAL_NAME_INPUT"] = "my-profile-social-name-input";
  MyProfileDataTestIdEnum2["MY_PROFILE_EMAIL_INPUT"] = "my-profile-email-input";
  MyProfileDataTestIdEnum2["MY_PROFILE_GENDER_FEMALE_RADIO"] = "my-profile-gender-female-radio";
  MyProfileDataTestIdEnum2["MY_PROFILE_GENDER_MALE_RADIO"] = "my-profile-gender-male-radio";
  MyProfileDataTestIdEnum2["MY_PROFILE_GENDER_NONBINARY_RADIO"] = "my-profile-gender-nonbinary-radio";
  MyProfileDataTestIdEnum2["MY_PROFILE_GENDER_NOT_INFORMED_RADIO"] = "my-profile-gender-not-informed-radio";
  MyProfileDataTestIdEnum2["MY_PROFILE_BIRTHDAY_INPUT"] = "my-profile-birthday-input";
  MyProfileDataTestIdEnum2["MY_PROFILE_CELLPHONE_INPUT"] = "my-profile-cellphone-input";
  MyProfileDataTestIdEnum2["MY_PROFILE_ZIPCODE_INPUT"] = "my-profile-zipcode-input";
  MyProfileDataTestIdEnum2["MY_PROFILE_ADDRESS_LINE1_INPUT"] = "my-profile-address-line1-input";
  MyProfileDataTestIdEnum2["MY_PROFILE_ADDRESS_LINE2_INPUT"] = "my-profile-address-line2-input";
  MyProfileDataTestIdEnum2["MY_PROFILE_NUMBER_INPUT"] = "my-profile-number-input";
  MyProfileDataTestIdEnum2["MY_PROFILE_NEIGHBORHOOD_INPUT"] = "my-profile-neighborhood-input";
  MyProfileDataTestIdEnum2["MY_PROFILE_SUBMIT_BUTTON_DATA_TAB"] = "submit-button--user-profile-data-tab";
  return MyProfileDataTestIdEnum2;
})(MyProfileDataTestIdEnum || {});
export {
  MyProfileDataTestIdEnum
};
